import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Link,
  Typography
} from "@one-thd/sui-atomic-components";
import {
  NEW_PHONE_GET_OTP,
  NEW_PHONE_VERIFY_EVOICE_OTP,
  NEW_PHONE_VERIFY_OTP,
  OLD_PHONE_VERIFY_EVOICE_OTP,
  OLD_PHONE_VERIFY_OTP
} from "./PhoneSection";
import { FieldError } from "../../../common/fields";
import OtpField from "./OtpField";
import { isEmpty } from "lodash";
import VerifyPhoneNumberField from "./VerifyPhoneNumberField";

const submitAutomationId = "verify-phone-modal--button-submit";
const cancelAutomationId = "verify-phone-modal--button-cancel";
const evoiceAutomationId = "verify-phone-modal--button-evoice";
const smsAutomationId = "verify-phone-modal--button-new-sms-otp";
const otpEntryAutomationId = "verify-phone-modal--otp-field";
const phoneEntryAutomationId = "verify-phone-modal--phone-field";

const getFooterContent = (submitButtonText, closeModal, isSubmitDisabled) => {
  return <div className="sui-my-4">
    <Button fullWidth
            type="submit" 
            disabled={isSubmitDisabled}
            data-automation-id={submitAutomationId}>
        {submitButtonText}
    </Button>
    <div className="u--paddingSmall-top"/>
    <Button variant="secondary"
            fullWidth
            onClick={closeModal} 
            outline
            data-automation-id={cancelAutomationId}>
          Cancel
    </Button>
  </div>
};

const getModalContent = (modalType, phone, form, evoiceAction, evoiceErrorMessage, closeModal, textMeANewCode, errorMessageWhileAddingAPhoneFlow, phoneMeANewCodeAction, otpChannel, otpSelection) => {
  let content = null;
  if (form) {
    switch (modalType) {
      case NEW_PHONE_GET_OTP:
        content = <form onSubmit={form.handleSubmit} id="verify-phone-modal">
          <div>
            <div className="sui-my-4">
              <Typography>Enter your new number, and we&apos;ll confirm it&apos;s you by
                sending you a
                verification code.
              </Typography>
            </div>
            <VerifyPhoneNumberField
              autoFocus // eslint-disable-line
              otpDetails={form}
              dataAutomationId={phoneEntryAutomationId}/>
            {!isEmpty(form.status) &&
              <div className="form-input--error u--paddingSmall-top">
                <FieldError errors={[form.status]}/>
              </div>
            }
          </div>
          {getFooterContent("Verify New Phone", closeModal, form.values.phone.length === 0 || !isEmpty(form.errors))}
        </form>;
        break;
      case OLD_PHONE_VERIFY_OTP:
        content = <form onSubmit={form.handleSubmit} id="verify-phone-modal">
          <div className=" u--paddingLarge-bottom">
            <div className="u--paddingNormal-bottom">
              To edit a phone number, you&apos;ll need to confirm it&apos;s you by entering in a verification code we
              sent
              to {phone}.
            </div>
            <OtpField
              autoFocus // eslint-disable-line
              verifyOtpForm={form}
              placeholder="Enter Code"
              dataAutomationId={otpEntryAutomationId}/>
            {!isEmpty(form.status) &&
              <div className="form-input--error">
                <FieldError name="otp" errors={[form.status]}/>
              </div>
            }
            <button type="button" className="u__default-link u--paddingSmall-top"
                    data-automation-id={evoiceAutomationId}
                    onClick={evoiceAction}>Call Me With the Code Instead
            </button>
            {!isEmpty(evoiceErrorMessage) &&
              <div className="form-input--error u--paddingSmall-top">
                <FieldError errors={[evoiceErrorMessage]}/>
              </div>
            }
          </div>
          {getFooterContent("Verify", closeModal, form.values.otp.length === 0 || !isEmpty(form.errors))}
        </form>;
        break;
      case NEW_PHONE_VERIFY_OTP:
        content = <form onSubmit={form.handleSubmit} id="verify-phone-modal">
          <div className=" u--paddingLarge-bottom">
            <div className="sui-my-4">
              <Typography>
                Please enter the verification code we sent to
              </Typography>
              <Typography weight="bold">
                {phone}
              </Typography>
            </div>
            <OtpField
              autoFocus // eslint-disable-line
              verifyOtpForm={form}
              placeholder="Enter Code"
              dataAutomationId={otpEntryAutomationId}/>
            {!isEmpty(form.status) &&
              <div className="form-input--error">
                <FieldError name="otp" errors={[form.status]}/>
              </div>
            }
            {errorMessageWhileAddingAPhoneFlow && 
              <div className="form-input--error u--paddingSmall-top">
                <FieldError errors={[errorMessageWhileAddingAPhoneFlow]}/>
              </div>
            }
            {!isEmpty(evoiceErrorMessage) &&
              <div className="form-input--error u--paddingSmall-top">
                <FieldError errors={[evoiceErrorMessage]}/>
              </div>
            }
            <div className="sui-mt-4">
              <Link type="button"
                      data-automation-id={smsAutomationId}
                      onClick={()=>{textMeANewCode(); otpSelection("sms"); }}>
                        {otpChannel==="sms" ? "Resend the text message" : "Text me a new code"}
              </Link>
            </div>
            <div className="sui-mt-4">
              <Link type="button"
                      data-automation-id={evoiceAutomationId}
                      onClick={()=>{phoneMeANewCodeAction(); otpSelection("phone"); }}>
                         {otpChannel==="phone" ? "Call me again with new code." : "Call me with a new code"}
              </Link>
            </div>
          </div>
          {getFooterContent("Verify", closeModal, form.values.otp.length === 0 || !isEmpty(form.errors))}
        </form>
        break;
      case OLD_PHONE_VERIFY_EVOICE_OTP:
      case NEW_PHONE_VERIFY_EVOICE_OTP:
        content = <form onSubmit={form.handleSubmit} id="verify-phone-modal">
          <div className=" u--paddingXlarge-top">
            <OtpField
              autoFocus // eslint-disable-line
              verifyOtpForm={form}
              placeholder="Enter Code"
              dataAutomationId={otpEntryAutomationId}/>
            {!isEmpty(form.status) &&
              <div className="form-input--error u--paddingSmall-top">
                <FieldError name="otp" errors={[form.status]}/>
              </div>
            }
            <span className="alert-inline alert-inline--success inline sui-my-4">
                We&apos;re calling you with a verification code at {phone}. Please enter the verification code above.
            </span>
          </div>
          {getFooterContent("Verify", closeModal, form.values.otp.length === 0 || !isEmpty(form.errors))}
        </form>
        break;
    }
  }
  return content;
}

function VerifyPhoneModal(props) {
  const { isOpen, modalType, closeModal, modalHeader, phoneNumber, form, evoiceAction, evoiceErrorMessage, textMeANewCode, errorMessageWhileAddingAPhoneFlow, phoneMeANewCodeAction } = props;
  const close = () => {
    form.resetForm();
    closeModal();
  }

  const[otpChannel, setOTPChannel] = React.useState("sms");
  const otpSelection = (selection) => setOTPChannel(selection)

  const content = getModalContent(modalType, phoneNumber, form, evoiceAction, evoiceErrorMessage, close, textMeANewCode, errorMessageWhileAddingAPhoneFlow, phoneMeANewCodeAction, otpChannel, otpSelection);
  return (
    <Modal
      open={isOpen}
      closeModal={close}
    >
      <ModalHeader>
        {modalHeader}
      </ModalHeader>
      <ModalBody>
        {content}
      </ModalBody>
    </Modal>
  );
}

export default VerifyPhoneModal;
